export default function Metrics() {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold mb-4">Metrics</h1>
      <p className="text-gray-600">View data quality and performance metrics</p>
    </div>
  );
}

